import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Login from "./pages/login";
import DashboardLayout from "./layouts/dashboard";
import ProtectedRoute from "./components/protectedRoute";
import CashoutPage from "./pages/cashout";
import UseradministrationPage from "./pages/createaccount";
import roleRoutes from "./routes/roleRoutes";
import useSessionTimeout from "./lib/session";
function App() {
  const isAuthenticated = useSelector((state) => state.login.isAuthenticated);
  const userData = useSelector((state) => state.login.user);
  const userRole = userData?.role && userData?.role;

  useSessionTimeout();
  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
        />
        <Route
          path="/useradministration"
          element={<UseradministrationPage />}
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {(roleRoutes[userRole] || []).map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  {route.element}
                </ProtectedRoute>
              }
            />
          ))}
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;
